/* src/modules/profile/cards/ChangePasswordCard/styles.js */

export default theme => ({
  paper: {
    padding: theme.spacing.unit * 3,
  },
  buttonContainer: {
    paddingTop: theme.spacing.unit * 3,
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse',
  },
});



// WEBPACK FOOTER //
// ./src/modules/profile/cards/ChangePasswordCard/styles.js